import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Button, Dropdown, DropdownProps, MenuProps, Space } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faFile,
  faFilePdf,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";

type MenuItem = Required<MenuProps>["items"][number];

const functionStyles: DropdownProps["styles"] = (info) => {
  const { props } = info;
  const isClick = props.trigger?.includes("click");
  if (isClick) {
    return {
      root: {
        borderColor: "#EBECED",
        borderRadius: "10px",
      },
    } satisfies DropdownProps["styles"];
  }
  return {};
};

const SharePage: React.FC<any> = ({ printRef }) => {
  const downloadImage = async () => {
    const canvas = await html2canvas(printRef.current, {
      scale: 2,
      backgroundColor: "#f5f5f5",
    });
    const image = canvas.toDataURL("image/jpeg", 1.0);

    const link = document.createElement("a");
    link.href = image;
    link.download = "page-screenshot.jpg";
    link.click();
  };

  const downloadPDF = async () => {
    const canvas = await html2canvas(printRef.current, {
      scale: 2,
      backgroundColor: "#f5f5f5",
    });
    const image = canvas.toDataURL("image/jpeg", 1.0);

    const pdf = new jsPDF("l", "mm", "a4");
    const width = pdf.internal.pageSize.getWidth();
    const height = (canvas.height * width) / canvas.width;

    pdf.addImage(image, "JPEG", 0, 0, width, height);
    pdf.save("page-screenshot.pdf");
  };

  const items: MenuItem[] = [
    {
      key: "sub1",
      icon: <FontAwesomeIcon icon={faFilePdf} style={{color: '#99A0A7', minWidth: '16px', minHeight: '16px', paddingRight: '5px'}}/>,
      label: "PDF",
      onClick: () => {
        console.log("pdf");
        downloadPDF();
      },
    },
    {
      key: "sub2",
      icon: <FontAwesomeIcon icon={faFile} style={{color: '#99A0A7', minWidth: '16px', minHeight: '16px', paddingRight: '5px'}}/>,
      label: "JPG",
      onClick: () => {
        console.log("jog");
        downloadImage();
      },
    },
  ];

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomLeft"
      styles={functionStyles}
      trigger={["click"]}
    >
      <Button type="primary" style={{padding: '8px 12px', width: '150px', height: '36px', borderRadius: '8px', fontWeight: 700, fontSize: '14px'}}>
        <Space>
          <FontAwesomeIcon icon={faShareNodes} />
          Share
          <FontAwesomeIcon icon={faAngleDown} />
        </Space>
      </Button>
    </Dropdown>
  );
};

export default SharePage;
